
				var addMethods = require("../../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["receiveMessageFromMaster"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "4d6a49f114d8dd778ffe.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			